import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import API from "../api/api";
import "./AllFeedbacks.css";

const AllFeedbacks = () => {
  const [feedbacks, setFeedbacks] = useState([]);

  // ✅ Load all feedbacks
  const loadFeedbacks = async () => {
    try {
      const res = await API.get("/feedbacks");
      setFeedbacks(res.data);
    } catch (err) {
      Swal.fire("Unauthorized", "You must be logged in as Admin to view feedbacks.", "error");
    }
  };

  useEffect(() => {
    loadFeedbacks();
  }, []);

  // ✅ Delete feedback with confirmation
  const deleteFeedback = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete this feedback?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#fe6e03",
      cancelButtonColor: "#021473",
    });

    if (!confirm.isConfirmed) return;

    try {
      await API.delete(`/feedbacks/${id}`);
      setFeedbacks((prev) => prev.filter((fb) => fb._id !== id));

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Feedback has been removed successfully.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch {
      Swal.fire("Error", "Failed to delete feedback.", "error");
    }
  };

  return (
    <div className="feedback-wrapper">
      <div className="feedback-card shadow-lg">
        <h3 className="feedback-title">All User Feedbacks</h3>
        <div className="underline"></div>

        {feedbacks.length === 0 ? (
          <p className="no-data text-center mt-4">No feedback submitted yet.</p>
        ) : (
          <div className="feedback-list">
            {feedbacks.map((fb) => (
              <div key={fb._id} className="feedback-box shadow-sm">
                <div className="feedback-header">
                  <h5 className="name">{fb.name || "Anonymous"}</h5>
                  <p className="email small">{fb.email || "-"}</p>
                </div>

                {fb.website && (
                  <p className="small website">
                    <strong>Website:</strong> {fb.website}
                  </p>
                )}

                <p className="comment">{fb.comment}</p>
                <p className="time small">{new Date(fb.createdAt).toLocaleString()}</p>

                <button
                  className="btn delete-btn btn-sm"
                  onClick={() => deleteFeedback(fb._id)}
                >
                  Delete Feedback
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AllFeedbacks;
